export function getNonUniqueOptionValueError(val) {
  return new Error(
    `Options in a select component must have a unique value. Value: ${JSON.stringify(
      val
    )}`
  );
}
